import React from 'react';
import { Link } from 'react-router-dom';

type HubCard = {
  to: string;
  title: string;
  ekos: string;
  blurb: string;
  testId: string;
};

const CARDS: HubCard[] = [
  {
    to: '/reporting/abc/taproom-sales',
    title: 'Taproom sales',
    ekos: 'Ekos: Sales — Item Details (cases / 1/6 / 1/4 / 1/2 BBL by company)',
    blurb: 'Quantities sold to OBB Taproom (Madison) and OBBA Taproom (Athens).',
    testId: 'report-card-taproom-sales',
  },
  {
    to: '/reporting/abc/distributor-invoices',
    title: 'Distributor invoices',
    ekos: 'Ekos: Previous Month Invoice Details by Distributor',
    blurb: 'Posted wholesaler invoices. $0 taproom invoices stay on the taproom report.',
    testId: 'report-card-distributor-invoices',
  },
  {
    to: '/reporting/abc/transfers',
    title: 'Beer transfers',
    ekos: 'Ekos: Inventory → Transfers',
    blurb: 'Completed beer moves between Madison and Athens brewery coolers. Taproom-order transfers are hidden unless you include them.',
    testId: 'report-card-transfers',
  },
  {
    to: '/reporting/abc/packaging',
    title: 'Batch packaging',
    ekos: 'Ekos: Batch — Packaging Details per location',
    blurb: 'What was packaged in the month, by site. Seltzer is left off.',
    testId: 'report-card-packaging',
  },
  {
    to: '/reporting/abc/inventory-as-of',
    title: 'Inventory as of date',
    ekos: 'Ekos: Inventory — As Of Date — Grouped by Packaging Type',
    blurb: 'Finished beer in the brewery coolers, rebuilt from inventory history. Seltzer is left off.',
    testId: 'report-card-inventory-as-of',
  },
  {
    to: '/reporting/ttb',
    title: 'TTB Brewer’s Report of Operations',
    ekos: 'TTB F 5130.9',
    blurb: 'Quarterly brewer’s report for Madison and Athens.',
    testId: 'report-card-ttb',
  },
  {
    to: '/monthly-inventory-counts',
    title: 'Monthly Inventory Count',
    ekos: '27 CFR 25.294',
    blurb: 'Physical inventory of brewery cooler packaged beer and bulk in tanks. Differences post to TTB lines 11 and 31.',
    testId: 'report-card-monthly-inventory',
  },
];

const ReportsHub: React.FC = () => {
  return (
    <div className="reports-hub" data-testid="reports-hub">
      <h2 className="app-header">Reports</h2>
      <p className="reports-hub__intro">
        Alabama ABC beer returns use these the same way the Ekos reports did. Pick a report, set the
        month or as-of date and Madison / Athens, then export CSV.
      </p>
      <div className="reports-hub__grid">
        {CARDS.map((card) => (
          <Link key={card.to} to={card.to} className="flow-card tappable reports-hub__card" data-testid={card.testId}>
            <h3 className="flow-card-title">{card.title}</h3>
            <p className="reports-hub__ekos">{card.ekos}</p>
            <p className="flow-card-meta">{card.blurb}</p>
          </Link>
        ))}
      </div>
      <p className="reports-hub__footnote">
        Toast pours (BMFG-6) and filling the BMFG-1 spreadsheet are not in Tilly yet.{' '}
        <Link to="/reporting/legacy">Older monthly and daily summaries</Link>
      </p>
    </div>
  );
};

export default ReportsHub;
